import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-popover-tab-pending',
  templateUrl: './popover-tab-pending.component.html',
  styleUrls: ['./popover-tab-pending.component.scss'],
})
export class PopoverTabPendingComponent {
  public items = [
    {
      text: `${this.translate.instant('SURVEYS.TAB_PENDING.PERFORM_INSPECTION')}`,
      functionIndex: 0,
      color: 'text-primary-dark',
    },
    {
      text: `${this.translate.instant('SURVEYS.TAB_PENDING.SEE_ON_THE_MAP')}`,
      functionIndex: 4,
      color: 'text-primary-dark',
    },
    {
      text: `${this.translate.instant('SURVEYS.TAB_PENDING.EDIT_SURVEY')}`,
      functionIndex: 1,
      color: 'text-primary-dark',
    },
    {
      text: `${this.translate.instant('SURVEYS.TAB_PENDING.TRANSFER_SURVEY')}`,
      functionIndex: 2,
      color: 'text-primary-dark',
    },
    {
      text: `${this.translate.instant('SURVEYS.TAB_PENDING.DELETE_INSPECTION')}`,
      functionIndex: 3,
      color: 'text-danger',
    },
  ];

  constructor(private popoverController: PopoverController, private translate: TranslateService) {}

  async dismiss(index: number) {
    await this.popoverController.dismiss({ functionIndex: this.items[index].functionIndex });
  }
}
